<template>
  <div class="integracoes-painel-table">
    <F360ScreenFrame interactive-table>
      <div class="integracoes-painel-table-header">
        <div class="integracoes-painel-table-header-actions">
          <PButton
            suffix-icon="sync_alt"
            :loading="isLoading"
            :disabled="!handleCanBuscarNovamente"
            @click="handleBuscarNovamente"
            >Buscar novamente</PButton
          >
          <PButton
            suffix-icon="add"
            type="outline"
            :loading="isLoading"
            @click="handleAdicionarIntegracao"
            >Adicionar integração</PButton
          >
        </div>
        <div
          class="integracoes-painel-table-header-actions integracoes-painel-table-header-actions--secondary"
        >
          <PButton
            prefix-icon="refresh"
            type="link"
            @click="obterWebservices"
            :loading="isLoading"
            >Atualizar</PButton
          >
        </div>
      </div>
      <PTable
        ref="tableRef"
        :columns="undefined"
        :data="tableData"
        :loading="isLoading"
        :stripe="true"
        :pagination="true"
        :page="pagination.paginaAtual"
        :total-pages="pagination.totalPages"
        :total="pagination.totalItens"
        :quantidadePorPagina="pagination.quantidadePorPagina"
        highlight-selected-rows
        row-click-mode="single"
        :row-clickable="canSelectRowForBuscarNovamente"
        @pagination="handlePagination"
        @linhas="handleLinhas"
        @selection-change="handleSelectionChange"
      >
        <PTableColumn
          type="selection"
          width="44"
          align="center"
          :resizable="false"
          :reserve-selection="true"
          :selectable="canSelectRowForBuscarNovamente"
        />
        <PTableColumn label="Integração" prop="integracao" min-width="260">
          <template #header>
            <PTableHeader
              id="integracao-multiple"
              label="Integração"
              prop="Webservice"
              :tableFilter="filtersPainelIntegracoesTable.integracao"
              :hasFilter="filtersPainelIntegracoesTable.integracao !== ''"
              :active-sort-id="filtersPainelIntegracoesTable.sort"
              hasClear
              sortable
              @aplicarFiltro="
                handleApplySearch(EFiltersPainelIntegracoesTable.INTEGRACAO)
              "
              @clearFiltro="
                handleClearSearch(EFiltersPainelIntegracoesTable.INTEGRACAO)
              "
              @onSort="handleSort"
            >
              <template #form>
                <PSelect
                  v-model="filtersPainelIntegracoesTable.integracao"
                  :options="listaWebservicesOpt"
                  placeholder="Selecione a integração"
                  clearable
                  filterable
                  full
                />
              </template>
            </PTableHeader>
          </template>
        </PTableColumn>
        <PTableColumn label="Tipo" prop="tipo" width="100">
          <template #header>
            <PTableHeader
              id="type-multiple"
              label="Tipo"
              prop="Tipo"
              :tableFilter="filtersPainelIntegracoesTable.integrationType"
              :hasFilter="filtersPainelIntegracoesTable.integrationType !== ''"
              hasClear
              @aplicarFiltro="
                handleApplySearch(EFiltersPainelIntegracoesTable.TYPE)
              "
              @clearFiltro="
                handleClearSearch(EFiltersPainelIntegracoesTable.TYPE)
              "
            >
              <template #form>
                <PSelect
                  v-model="filtersPainelIntegracoesTable.integrationType"
                  :options="integrationTypeOptions"
                  placeholder="Selecione o tipo"
                  clearable
                  full
                />
              </template>
            </PTableHeader>
          </template>
          <template #default="{ row }">
            {{ row.tipo || "API" }}
          </template>
        </PTableColumn>
        <PTableColumn
          label="Última execução"
          prop="lastExecutionAt"
          width="180"
        >
          <template #header>
            <PTableHeader
              id="ultima-execucao-multiple"
              label="Última execução"
              prop="UltimaExecucaoEm"
              tableFilter=""
              :active-sort-id="filtersPainelIntegracoesTable.sort"
              only-sort
              sortable
              @onSort="handleSort"
            />
          </template>
          <template #default="{ row }">
            {{ formatLastExecution(row.lastExecutionAt) }}
          </template>
        </PTableColumn>
        <PTableColumn label="Empresa" prop="empresa" width="200">
          <template #header>
            <PTableHeader
              id="empresa-multiple"
              label="Empresa"
              prop="Outros"
              tableFilter=""
              :active-sort-id="filtersPainelIntegracoesTable.sort"
              only-sort
              sortable
              @onSort="handleSort"
            />
          </template>
          <template #default="{ row }">
            <el-tooltip :content="row.empresa || 'N/A'" placement="top">
              {{ handleTextEllipsis(row.empresa || "N/A", 22) }}
            </el-tooltip>
          </template>
        </PTableColumn>
        <PTableColumn label="Status" prop="status" width="40">
          <template #header>
            <PTableHeader
              id="status-multiple"
              label="Status"
              prop="Inativo"
              :tableFilter="filtersPainelIntegracoesTable.inativo"
              :hasFilter="filtersPainelIntegracoesTable.inativo !== undefined"
              :active-sort-id="filtersPainelIntegracoesTable.sort"
              hasClear
              sortable
              @aplicarFiltro="
                handleApplySearch(EFiltersPainelIntegracoesTable.STATUS)
              "
              @clearFiltro="
                handleClearSearch(EFiltersPainelIntegracoesTable.STATUS)
              "
              @onSort="handleSort"
            >
              <template #form>
                <PSelect
                  v-model="filtersPainelIntegracoesTable.inativo"
                  clearable
                  :options="[
                    { label: 'Inativo', value: 'true' },
                    { label: 'Ativo', value: 'false' }
                  ]"
                  placeholder="Selecione o status"
                  full
                />
              </template>
            </PTableHeader>
          </template>
        </PTableColumn>
        <PTableColumn
          label="Mais opções"
          align="center"
          width="106"
          :resizable="false"
        >
          <template #default="{ row }">
            <PTableActions
              v-if="row.tipo !== 'SFTP' && !row.IsSFTP"
              trigger="hover"
              aria-label="Abrir opções da integração"
              @command="handleDropdownCommand"
            >
              <PTableActionItem
                v-for="item in getIntegracaoActions(row)"
                :key="item.action"
                :command="{ action: item.action, row }"
                :icon="item.icon"
                :label="item.label"
              />
            </PTableActions>
          </template>
        </PTableColumn>
      </PTable>
    </F360ScreenFrame>
    <HistoricoIntegracaoDrawer
      v-if="visibleHistoricoDrawer"
      :webservice="selectedRow ?? ({} as TWebservice)"
      :painelIntegracoesGateway="painelIntegracoesGateway"
      @close="handleHistoricoClose"
    />

    <PModalAlerta
      v-model="visibleModalAlerta"
      :type="EF360AlertTypesMapper.error"
      title="Atenção"
      width="400"
      @handleConfirmar="handleConfirmarDeletarIntegracao"
      @handleFechar="visibleModalAlerta = false"
    >
      <template #titulo>
        <span>Atenção</span>
      </template>
      <template #content>
        <div style="height: 100px; text-align: left">
          Tem certeza que deseja excluir esse registro? Iremos excluir todos os
          logs de comunicação com esse serviço. <br /><br />
          <div><b>Essa operação não poderá ser desfeita.</b></div>
        </div>
      </template>
    </PModalAlerta>

    <PModalAlerta
      v-model="visibleModalDesativarIntegracao"
      :type="EF360AlertTypesMapper.error"
      :loading="isLoading"
      title="Atenção"
      width="400"
      @handleConfirmar="handleConfirmarDesativarIntegracao"
      @handleFechar="visibleModalDesativarIntegracao = false"
    >
      <template #titulo>
        <span>Atenção</span>
      </template>
      <template #content>
        <div style="height: 100px; text-align: left">
          <p>
            A busca automática de dados será interrompida e as informações não
            serão atualizadas.
          </p>
          <p>Os dados não serão mais atualizados até que ela seja reativada.</p>
        </div>
      </template>
    </PModalAlerta>

    <ChamarServicoDrawer
      :visibleDrawer="visibleChamarServicoDrawer"
      v-if="visibleChamarServicoDrawer"
      :webservice="selectedRow"
      :webservices="webservicesSelecionadosParaBuscar"
      @executed="handleChamarServicoExecuted"
      @close="handleChamarServicoClose"
    />

    <IntegrationRegistrationDrawer
      :visibleDrawer="visibleAdicionarIntegracao"
      :gateway="cadastroDeIntegracaoGateway"
      :mode="drawerMode"
      :webservice-id="selectedWebserviceId"
      :webservice-name="selectedWebserviceName"
      v-if="visibleAdicionarIntegracao"
      @onClose="handleAdicionarIntegracaoBeforeClose"
    />
  </div>
</template>

<script setup lang="ts">
import F360ScreenFrame from "@/ui/components/Layout/Main/ScreenFrame/F360ScreenFrame.vue";
import {
  clearPrismaTableSelection,
  type PrismaTableRef
} from "@/ui/components/Tables/prismaTableRef";
import {
  PButton,
  PModalAlerta,
  PSelect,
  PTableActionItem,
  PTableActions,
  PTableColumn,
  PTableHeader,
  PTable
} from "@f360-dev/f360-prisma";
import {
  PainelDeIntegracaoesDi,
  PainelDeIntegracaoesGateway,
  TIntegrationType,
  TWebservice
} from "../../services/PainelDeIntegracaoesGateway";
import { diContainer } from "@/inversify.config";
import { computed, onMounted, reactive, ref } from "vue";
import HistoricoIntegracaoDrawer from "../historico/HistoricoIntegracaoDrawer.vue";
import useDeletarIntegracao from "../../composables/useDeletarIntegracao";
import { EF360AlertTypesMapper } from "@/core/@types/enums";
import useToggleIntegracao from "../../composables/useToggleIntegracao";
import { EFiltersPainelIntegracoesTable } from "./types";
import ChamarServicoDrawer from "../chamarServico/ChamarServicoDrawer.vue";
import { handleTextEllipsis } from "@/core/common/utils";
import IntegrationRegistrationDrawer from "../cadastro/IntegrationRegistrationDrawer/IntegrationRegistrationDrawer.vue";
import { useIntegracoesStore } from "../../../../store/useIntegracoesStore";
import { storeToRefs } from "pinia";
import { IFinancasFeatureGateway } from "@/features/financas/services/ports/FinancasFeatureGateway";
import { DITypes } from "@/core/@types/types";
import {
  CadastroDeIntegracaoDi,
  CadastroDeIntegracaoGateway
} from "../cadastro/services/CadastroDeIntegracaoGateway";
import useDate from "@/core/plugins/useDate";
import {
  resolveApiRules,
  supportsSubmitChamarServico
} from "../chamarServico/composables/chamarServicoRequest";
import useAnalyticsIntegracoes, {
  AnalyticsIntegracoesHistoryOrigin
} from "../../../../analytics/useAnalyticsIntegracoes";
import useStickyPageContext from "@/core/composables/useStickyPageContext/useStickyPageContext";

const isLoading = ref(false);
const selectedRow = ref<TWebservice | undefined>(undefined);
const selectedRows = ref<TWebservice[]>([]);
const tableRef = ref<PrismaTableRef | null>(null);

const visibleHistoricoDrawer = ref(false);
const visibleModalAlerta = ref(false);
const visibleModalDesativarIntegracao = ref(false);
const visibleChamarServicoDrawer = ref(false);
const visibleAdicionarIntegracao = ref(false);
const drawerMode = ref<"create" | "edit">("create");
const selectedWebserviceId = ref<string | null>(null);
const selectedWebserviceName = ref<string | null>(null);

const tableData = ref<any[]>([]);

const painelIntegracoesGateway = diContainer.get<PainelDeIntegracaoesGateway>(
  PainelDeIntegracaoesDi
);
const dateLib = useDate();

const formatLastExecution = (value?: string | null) =>
  value ? dateLib.format(value, "DD/MM/YY [às] HH:mm") : "-";

const financasFeatureGateway = diContainer.get<IFinancasFeatureGateway>(
  DITypes.FINANCAS_FEATURES
);

const cadastroDeIntegracaoGateway =
  diContainer.get<CadastroDeIntegracaoGateway>(CadastroDeIntegracaoDi);

const integracoesStore = useIntegracoesStore();
const { listaWebservicesOpt } = storeToRefs(integracoesStore);

const { deletarIntegracao } = useDeletarIntegracao(painelIntegracoesGateway);
const { toggleIntegracao } = useToggleIntegracao(painelIntegracoesGateway);
const {
  sendSearchIntegration,
  sendDeleteIntegration,
  sendToggleIntegrationStatus,
  sendOpenHistory
} = useAnalyticsIntegracoes();

useStickyPageContext();

const filtersPainelIntegracoesTable = ref<{
  integracao: string;
  status: string;
  inativo?: string | undefined;
  integrationType: TIntegrationType | "";
  sort: string;
}>({
  integracao: "",
  status: "",
  inativo: undefined,
  integrationType: "",
  sort: "Inativo-asc"
});

const integrationTypeOptions: Array<{
  label: TIntegrationType;
  value: TIntegrationType;
}> = [
  { label: "API", value: "API" },
  { label: "SFTP", value: "SFTP" },
  { label: "Webhook", value: "Webhook" }
];

const pagination = reactive({
  paginaAtual: 1,
  quantidadePorPagina: 25,
  totalItens: 0,
  totalPages: 0
});

type TDropdownCommand = {
  action: "historico" | "edit" | "desativar" | "ativar" | "delete";
  row?: TWebservice;
};

const isRowUnavailableForBuscarNovamente = (row?: TWebservice) => {
  if (!row) return true;

  return (
    row.Inativo ||
    row.status === "Inativo" ||
    row.integracao === "FXData" ||
    row.integracao === "API Pública da F360" ||
    row.integracao === "Webservices"
  );
};

const getIntegrationType = (row?: TWebservice) => {
  const type = row?.tipo ?? row?.Tipo;

  if (typeof type === "string") {
    const normalizedType = type.trim().toUpperCase();

    if (normalizedType === "SFTP") return "SFTP";
    if (normalizedType === "WEBHOOK") return "Webhook";
    if (normalizedType === "API") return "API";
  }

  return row?.IsSFTP ? "SFTP" : "API";
};

const isSftpIntegration = (row?: TWebservice) =>
  getIntegrationType(row) === "SFTP";

const getBackendIntegrationId = (row?: TWebservice) => row?._id ?? row?.id;

const getTableRowId = (row: TWebservice, tipo: string) =>
  tipo === "SFTP" ? `${row._id}:SFTP:${row.VanEntidade ?? ""}` : row._id;

const resolveRowApiRules = (row?: TWebservice) => {
  if (isSftpIntegration(row)) return undefined;

  return resolveApiRules(row?.API_Hash, row?.integracao?.toString());
};

const canSubmitBuscarNovamenteForRow = (row?: TWebservice) => {
  if (isRowUnavailableForBuscarNovamente(row)) return false;

  if (isSftpIntegration(row)) {
    const id = getBackendIntegrationId(row);
    const entity = row?.VanEntidade;

    return Boolean(id && entity != null && Number(entity) > 0);
  }

  const apiRules = resolveRowApiRules(row);

  return supportsSubmitChamarServico(apiRules);
};

const canSelectRowForBuscarNovamente = (row?: TWebservice) => {
  return canSubmitBuscarNovamenteForRow(row);
};

const webservicesSelecionadosParaBuscar = computed(() => {
  return selectedRows.value;
});

const handleCanBuscarNovamente = computed(() => {
  return (
    !isLoading.value &&
    selectedRows.value.length > 0 &&
    selectedRows.value.every((row) => canSubmitBuscarNovamenteForRow(row))
  );
});

const handlePagination = (page: number) => {
  if (isLoading.value) return;
  pagination.paginaAtual = page;
  obterWebservices();
};

const handleLinhas = (linhas: number) => {
  if (isLoading.value) return;
  pagination.quantidadePorPagina = linhas;
  obterWebservices();
};

const getIntegrationName = (row?: TWebservice) =>
  row?.integracao?.toString() || row?.Webservice?.toString() || "";

const getFilterIntegrationName = () => {
  const integration = filtersPainelIntegracoesTable.value.integracao;
  if (!integration) return "";

  const option = listaWebservicesOpt.value.find(
    (item) => String(item.value) === String(integration)
  );

  return option?.label || String(integration);
};

const handleEdit = (row?: TWebservice) => {
  const id = getBackendIntegrationId(row);
  if (!id) return;

  selectedRow.value = row;
  selectedWebserviceId.value = id;
  selectedWebserviceName.value = getIntegrationName(row);
  drawerMode.value = "edit";
  visibleAdicionarIntegracao.value = true;
};

const handleDelete = (row?: TWebservice) => {
  visibleModalAlerta.value = false;
  selectedRow.value = row;
  visibleModalAlerta.value = true;
};

const handleConfirmarDeletarIntegracao = async () => {
  const integrationName = getIntegrationName(selectedRow.value);
  const result = await deletarIntegracao(selectedRow.value);

  if (result) {
    sendDeleteIntegration(integrationName);
    obterWebservices();
  }

  visibleModalAlerta.value = false;
};

const handleDropdownCommand = async ({ action, row }: TDropdownCommand) => {
  if (action === "historico") {
    handleHistoricoClick(row);

    return;
  }

  if (action === "edit") {
    handleEdit(row);

    return;
  }

  if (action === "desativar") {
    handleDesativarIntegracao(row);

    return;
  }

  if (action === "ativar") {
    await handleAtivarIntegracao(row);

    return;
  }

  handleDelete(row);
};

const handleAtivarIntegracao = async (row?: TWebservice) => {
  const integrationName = getIntegrationName(row);
  const result = await toggleIntegracao(true, row);

  if (result) {
    sendToggleIntegrationStatus(integrationName, true);
    await obterWebservices();
  }
};

const handleDesativarIntegracao = (row?: TWebservice) => {
  selectedRow.value = row;
  visibleModalDesativarIntegracao.value = true;
};

const handleConfirmarDesativarIntegracao = async () => {
  const integrationName = getIntegrationName(selectedRow.value);
  const result = await toggleIntegracao(false, selectedRow.value);

  if (result) {
    sendToggleIntegrationStatus(integrationName, false);
    await obterWebservices();
  }

  visibleModalDesativarIntegracao.value = false;
};

const handleHistoricoClick = (
  row?: TWebservice,
  origin: AnalyticsIntegracoesHistoryOrigin = AnalyticsIntegracoesHistoryOrigin.MoreOptions
) => {
  selectedRow.value = row;
  sendOpenHistory(getIntegrationName(row), origin);
  visibleHistoricoDrawer.value = true;
};

const handleHistoricoClose = () => {
  visibleHistoricoDrawer.value = false;
};

const handleMostrarHistorico = (row?: TWebservice) => {
  return (
    row &&
    !isSftpIntegration(row) &&
    row.status === "Ativo" &&
    row.integracao !== "FXData" &&
    row.integracao !== "API Pública da F360" &&
    row.integracao !== "Webservices"
  );
};

type TIntegracaoAction = {
  action: TDropdownCommand["action"];
  icon: string;
  label: string;
  isVisible?: (row: TWebservice) => boolean;
};

const INTEGRACAO_ACTIONS: TIntegracaoAction[] = [
  {
    action: "historico",
    icon: "source_notes",
    label: "Histórico",
    isVisible: (row) => Boolean(handleMostrarHistorico(row))
  },
  { action: "edit", icon: "edit", label: "Editar" },
  {
    action: "desativar",
    icon: "close",
    label: "Desativar",
    isVisible: (row) => row.status === "Ativo"
  },
  {
    action: "ativar",
    icon: "check",
    label: "Ativar",
    isVisible: (row) => row.status === "Inativo"
  },
  { action: "delete", icon: "delete", label: "Excluir" }
];

const getIntegracaoActions = (row: TWebservice) =>
  INTEGRACAO_ACTIONS.filter(({ isVisible }) => !isVisible || isVisible(row));

const getIntegrationKey = (row?: TWebservice) =>
  `${getIntegrationType(row)}:${getBackendIntegrationId(row)}:${row?.VanEntidade ?? ""}`;

const carregarWebservices = async (preserveSelection: boolean) => {
  if (isLoading.value) return;

  const selectedRowKey = preserveSelection
    ? getIntegrationKey(selectedRow.value)
    : undefined;
  const selectedIntegrationKeys = preserveSelection
    ? new Set(selectedRows.value.map(getIntegrationKey))
    : new Set<string>();

  if (!preserveSelection) {
    clearPrismaTableSelection(tableRef.value);
    selectedRow.value = undefined;
    selectedRows.value = [];
  }

  try {
    isLoading.value = true;
    const response = await painelIntegracoesGateway.obterWebservices({
      ...filtersPainelIntegracoesTable.value,
      page: pagination.paginaAtual,
      pageSize: pagination.quantidadePorPagina,
      api: filtersPainelIntegracoesTable.value.integracao,
      inativo: filtersPainelIntegracoesTable.value.inativo as any,
      integrationType:
        filtersPainelIntegracoesTable.value.integrationType || undefined
    });

    // TODO[FINC-1618]: listar integrações pela nova API do New Horizons.

    if (response?.Ok && response?.Data) {
      const refreshedTableData = response.Data.map((item) => {
        const tipo = getIntegrationType(item);

        return {
          id: getTableRowId(item, tipo),
          _id: item._id,
          integracao: item.Webservice ?? "",
          status: item.Inativo ? "Inativo" : "Ativo",
          empresa: item.Outros ?? "",
          lastExecutionAt:
            item.UltimaExecucaoEm ?? item.UltimoReprocessamento ?? null,
          Inativo: item.Inativo,
          tipo,
          // eslint-disable-next-line camelcase
          API_Hash: item.API_Hash,
          ...(tipo === "SFTP"
            ? {
                IsSFTP: true,
                VanEntidade: item.VanEntidade,
                UltimoReprocessamento: item.UltimoReprocessamento
              }
            : {})
        };
      });
      tableData.value = refreshedTableData;

      if (preserveSelection) {
        selectedRows.value = refreshedTableData.filter((row) =>
          selectedIntegrationKeys.has(getIntegrationKey(row))
        );
        selectedRow.value = refreshedTableData.find(
          (row) => getIntegrationKey(row) === selectedRowKey
        );
      }

      pagination.totalItens = response.Total ?? 0;
      pagination.totalPages = Math.ceil(
        pagination.totalItens / pagination.quantidadePorPagina
      );
    }
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};

const obterWebservices = async () => carregarWebservices(false);

const handleApplySearch = (filtro: EFiltersPainelIntegracoesTable) => {
  if (filtro === EFiltersPainelIntegracoesTable.INTEGRACAO) {
    const integrationName = getFilterIntegrationName();

    if (integrationName) sendSearchIntegration(integrationName);
  }

  pagination.paginaAtual = 1;
  obterWebservices();
};

const clearFilterActions: Record<EFiltersPainelIntegracoesTable, () => void> = {
  [EFiltersPainelIntegracoesTable.INTEGRACAO]: () => {
    filtersPainelIntegracoesTable.value.integracao = "";
  },
  [EFiltersPainelIntegracoesTable.STATUS]: () => {
    filtersPainelIntegracoesTable.value.status = "";
    filtersPainelIntegracoesTable.value.inativo = undefined;
  },
  [EFiltersPainelIntegracoesTable.TYPE]: () => {
    filtersPainelIntegracoesTable.value.integrationType = "";
  }
};

const handleClearSearch = (filter: EFiltersPainelIntegracoesTable) => {
  clearFilterActions[filter]();
  pagination.paginaAtual = 1;
  obterWebservices();
};

const handleSort = (order: string) => {
  if (isLoading.value) return;

  filtersPainelIntegracoesTable.value.sort = order;
  pagination.paginaAtual = 1;
  obterWebservices();
};

const handleBuscarNovamente = () => {
  if (!handleCanBuscarNovamente.value) return;
  visibleChamarServicoDrawer.value = true;
};

const handleSelectionChange = (rows: TWebservice[]) => {
  selectedRows.value = rows;
  selectedRow.value = rows.at(-1);
};

const handleChamarServicoClose = async (payload?: { executed?: boolean }) => {
  visibleChamarServicoDrawer.value = false;

  if (payload?.executed) {
    await obterWebservices();
  }
};

const handleChamarServicoExecuted = async () => {
  await carregarWebservices(true);
};

const handleAdicionarIntegracao = () => {
  drawerMode.value = "create";
  selectedWebserviceId.value = null;
  selectedWebserviceName.value = null;
  visibleAdicionarIntegracao.value = true;
};

const handleAdicionarIntegracaoBeforeClose = (payload?: { saved: boolean }) => {
  visibleAdicionarIntegracao.value = false;
  selectedWebserviceId.value = null;
  selectedWebserviceName.value = null;
  drawerMode.value = "create";
  if (payload?.saved) void obterWebservices();
};

const obterDadosAuxiliaresPainel = async () => {
  try {
    isLoading.value = true;

    await Promise.all([
      integracoesStore.obterListaWebservices(painelIntegracoesGateway),
      integracoesStore.obterFornecedoresConfiaveis(financasFeatureGateway),
      integracoesStore.obterMunicipiosOpt(cadastroDeIntegracaoGateway)
    ]);
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};

onMounted(async () => {
  await obterWebservices();
  await obterDadosAuxiliaresPainel();
});
</script>

<style scoped lang="scss" src="./PainelIntegracoesTable.scss"></style>
